import Cookies from "js-cookie"
import { q, qq } from "../../../helper/q"

export default {
  state: {
    load: false,
    open: false,
    currentRegion: undefined,
    currentCity: undefined,
    regions: {}
  },
  reducers: {
    open: state => {
      !state.open ? (document.body.style.overflow = "hidden") : (document.body.style.overflow = "auto")
      return { ...state, open: !state.open }
    },
    setCurrentRegion: (state, current) => {
      return { ...state, currentRegion: current }
    },
    setCurrentCity: (state, current) => {
      return { ...state, currentCity: current }
    },
    addRegion: (state, payload, region) => {
      return {
        ...state,
        regions: {
          ...state.regions,
          [region]: {
            payload
          }
        },
        currentRegion: region
      }
    },
    update: (state, payload) => {
      return { ...state, data: payload, load: true }
    }
  },
  effects: dispatch => ({
    getRegions: async () => {
      fetch("/ajax/region/list")
        .then(res => res.json())
        .then(data => {
          if (data.currentRegion) {
            fetch(`/ajax/region/${data.currentRegion}`)
              .then(res => res.json())
              .then(obj => mapToObject(transformCity(obj.region)))
              .then(region => dispatch.regions.addRegion(region, data.currentRegion))
          }
          dispatch.regions.setCurrentCity(data.currentCity)
          dispatch.regions.update(mapToObject(transformRegion(data.region)))
        })
    },

    getRegion: async (region, rootState) => {
      if (!rootState.regions.regions[region]) {
        fetch(`/ajax/region/${region}`)
          .then(res => res.json())
          .then(obj => mapToObject(transformCity(obj.region)))
          .then(data => dispatch.regions.addRegion(data, region))
      } else {
        dispatch.regions.setCurrentRegion(region)
      }
    },

    setCity: async ({ id, label }) => {
      fetch(` /ajax/region/set?id=${id}`)
        .then(res => res.json())
        .then(() => {
          dispatch.regions.setCurrentCity(id)
          dispatch.regions.open()
          if (q(".buttonLocation")) {
            q(".buttonLocation").innerHTML = label
            q(".buttonCityMobile span").innerHTML = label
            Cookies.set("regionask", "true", {
              expires: 3600,
              path: "/"
            })
            q(".locationTooltip").classList.remove("locationTooltipShow")
          }
        })
    }
  })
}

const transformRegion = arr =>
  ((mapRegion, array) => (
    array.forEach(element => {
      const a = mapRegion.get(element.region[0]) || []
      mapRegion.set(element.region[0], (a.push(element), a))
    }),
    mapRegion
  ))(
    new Map(),
    Object.keys(arr).map(k => {
      return { ...arr[k], ids: k }
    })
  )

const transformCity = arr =>
  ((mapRegion, array) => (
    array.forEach(element => {
      const a = mapRegion.get(element.city[0]) || []
      mapRegion.set(element.city[0], (a.push(element), a))
    }),
    mapRegion
  ))(
    new Map(),
    Object.keys(arr).map(k => {
      return { ...arr[k], ids: k }
    })
  )

const mapToObject = aMap => {
  const obj = {}
  aMap.forEach((v, k) => {
    obj[k] = v
  })
  return Object.keys(obj).map(k => {
    return { values: obj[k], letter: k }
  })
}
